import styles from './style.form.css'

class AuthField extends React.Component {
  render () {
    let {input, meta, type, placeholder, icon, maxLength} = this.props
    let {touched, error} = meta
    return (
      <div>
        <div className={!touched ? styles['field-wrapper'] : error ? styles['field-error'] : styles['field-success']}>
          <i className={icon} />
          <input {...input} type={type} maxLength={maxLength} placeholder={placeholder} className={styles['field-input']} />
        </div>
        <small className='error'>{touched ? error : ''}</small>
      </div>
    )
  }
}

AuthField.propTypes = {
  icon: React.PropTypes.string
}

export default AuthField



// WEBPACK FOOTER //
// ./app/components/Fields/AuthField.js